import { FC, useCallback, useEffect, useRef, useState } from "react";
import styles from "./Settings.module.scss";
import setting from "../../images/icons/settings.svg";
import { Button } from "../ui";
import { ErrorPage } from "../../pages/ErrorPage/ErrorPage";
import {
  getModelsDocument,
  setIsBanned,
  setIsVerificate,
} from "../../api/user";
import Checkbox from "../ui/Checkbox/Checkbox";
import close from "../../images/icons/clear.svg";

interface ISettings {
  idModels: number;
}

export const Settings: FC<ISettings> = ({ idModels }) => {
  const [openSetting, setOpenSetting] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopupNotify, setOpenPopupNotify] = useState(false);
  const [textarea, setTextarea] = useState("");
  const [typeReq, setTypeReq] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState("");

  async function handleOpenDocument() {
    try {
      setIsLoading(true);
      await getModelsDocument(); //Переделать путь как будет запрос на беке
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }

  async function fetchDataVerif() {
    try {
      setIsLoading(true);
      const body = {
        status: "approved",
        reason: textarea,
      };
      await setIsVerificate(body, idModels);
      setOpenSetting(false);
      setOpenPopupNotify(true);
    } catch {
      return <ErrorPage />;
    } finally {
      setTextarea("");
      setStatus("");
      setIsLoading(false);
    }
  }

  async function fetchData() {
    try {
      setIsLoading(true);
      const body = {
        isBanned: true,
        reason: textarea,
      };
      await setIsBanned(body, idModels);
    } catch {
      return <ErrorPage />;
    } finally {
      setTextarea("");
      setOpenPopup(false);
      setIsLoading(false);
    }
  }
  async function fetchDataNotBanned() {
    try {
      setIsLoading(true);
      const body = {
        isBanned: false,
        reason: textarea,
      };
      await setIsBanned(body, idModels);
      setOpenPopupNotify(true);
      setOpenSetting(false);
    } catch {
      return <ErrorPage />;
    } finally {
      setTextarea("");
      setIsLoading(false);
    }
  }

  return (
    <div>
      <img
        className={styles.icon}
        src={setting}
        alt="SettingIcon"
        onClick={() => setOpenSetting(!openSetting)}
      />
      <div
        className={`${styles.settings} ${openSetting && styles.settings_open}`}
      >
        <p className={styles.settings_text} onClick={() => fetchDataVerif()}>
          Verifizieren
        </p>
        <p
          className={styles.settings_text}
          onClick={() => {
            setOpenPopup(true);
            setOpenSetting(false);
          }}
        >
          Verbannen
        </p>
        <p
          className={styles.settings_text}
          onClick={() => fetchDataNotBanned()}
        >
          Zerschlagen
        </p>
      </div>
      <div className={`${styles.popup} ${openPopup && styles.popup_opened}`}>
        <img
          className={styles.popup_iconClose}
          onClick={() => setOpenPopup(false)}
          src={close}
          alt="iconClose"
        />
        <div className={styles.popup__container}>
          <h5>Hinterlasse einen Kommentar für das Modell</h5>
          <div className={styles.textareaBlock}>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>Beschreibung</label>
              <textarea
                placeholder="Enter beschreibung..."
                value={textarea}
                className={styles.textarea}
                onChange={(e) => setTextarea(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div className={styles.Button}>
            <Button type="button" onClick={() => fetchData()}>
              Send
            </Button>
          </div>
        </div>
      </div>
      <div
        className={`${styles.popup} ${openPopupNotify && styles.popup_opened}`}
      >
        <img
          className={styles.popup_iconCloseNotify}
          onClick={() => setOpenPopupNotify(false)}
          src={close}
          alt="iconClose"
        />
        <div className={styles.popup_containerNotify}>
          <h5>Die Anforderung wurde erfolgreich ausgeführt</h5>
        </div>
      </div>
    </div>
  );
};
